import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import ListIcon from "@material-ui/icons/List";
import SendIcon from "@material-ui/icons/Send";

import MapIcon from "@material-ui/icons/Map";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Box from "@material-ui/core/Box";
import IconLabelButton from "./MyButton";
import Grid from "@material-ui/core/Grid";
import Moment from "react-moment";
import MaxWidthDialog from "./TestDialog";
import SuKienChiTietDialog from "./SuKienChiTietDialog";
import Container from "@material-ui/core/Container";
import { sizing, maxHeight } from "@material-ui/system";
import { Height } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import ChatTimKiemControl from "./controls/ChatTimKiemControl";
import CircularProgress from "@material-ui/core/CircularProgress";
import "react-chat-elements/dist/main.css";
import TrucBanDenEditDialog from "./TrucBanDenEditDialog";
import TrucBanDiEditDialog from "./TrucBanDiEditDialog";
import SelectFilter from "react-select";
import { MessageList } from "react-chat-elements";
import "./chat.css";
import "./controls/ChatBubble.css";
import { none } from "ol/centerconstraint";
const server = require("../lib/server.js");
const myLib = require("../lib/MyLib.js");
const PhuongThucGui = ["Khác", "Thoại", "Fax", "Email"];

class ChatOnlinePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: { Page: 1, PageSize: 10 }, //dieu kien tim kiem hien thoi
      dataRows: [], //danh sach ban ghi
      totalRows: 0, //tong so ban ghi

      loading_coquan: true, // co dang load ding danh muc nguon tin ko
      source_coquan: [], //danh muc options cho nguon tin
      loading_sukien: true,
      source_sukien: [],
      LastChatID: 0,
      MinChatID : 0,

      NoiDung: "",
      MaNoiNhan: [],
      MaSK: null,

      saving: false,
      errorLog: "",
      tempList: [],
    };
  }

  popupComp = undefined;
  timerHandle = undefined;
  handleSend() {
    //send chat
    this.setState({ saving: true, errorLog: "" });
    server
      .post("chat/send", {
        NoiDung: this.state.NoiDung,
        MaSK: this.state.MaSK,
        MaNoiNhan: this.state.MaNoiNhan,
      })
      .then((response) => {
        this.setState(
          {
            saving: false,
            errorLog: "",
            MaNoiNhan: [],
            MaSK: null,
            NoiDung: '',
          },
          () => {
            this.handleSearch(0);
          }
        );
      })
      .catch((error) => this.setState({ saving: false, errorLog: error + "" }));
  }
  componentDidMount() {
    this.loadDanhMuc();
    this.handleSearch();
    var that = this;
    this.timerHandle = setInterval(() => {
      that.onTimer();
    }, 10000);
  }
  componentWillUnmount() {
    clearInterval(this.timerHandle);
  }
  onTimer() {
    //console.log(new Date());
    this.handleSearch(0);
  }
  //call khi user thay doi trang
  handleSearch = (last) => {
    this.setState({ search_loading: true, errorLog: "" });
    server
      .post("chat/searchchats", { FromChatID: last, NumberRecord: 10 })
      .then((response) => {
        //tao danh sach hien thi
        var list = [];
        var lastID = 0, minID = 0;
        response.map((item, index) => {
          var text = item.NoiDung;
          var tensk = item.TenSK ? item.TenSK : "-";
          var noinhans = "";
          var hasRead = false;
          item.NoiNhans.map((n, i) => {
            if (n.DichDanh) {
              noinhans += (noinhans !== "" ? ",@" : "@") + n.TenVietTat;
            }
            if (n.MaCQ == global.User.MaCQ) {
              //cung tai khoan
              hasRead = n.HasRead;
            }
            if (n.ChatID > lastID) lastID = n.ChatID;
            if(n.ChatID < minID) minID = n.ChatID;
          });
          list.push({
            dataItem: item,
            position: item.ChieuGui ? "right" : "left",
            type: "text",
            text: (
              <pre
                id={"area" + item.ChatID}
                readOnly
                style={{
                  border: "none",
                  minWidth: 400,
                  minHeight: 48,
                  overflow: "auto",
                }}
              >
                {text}
              </pre>
            ),
            title: item.ChieuGui ? undefined : item.TenNoiGui,
            date: myLib.fromServerTime(item.NgayCN),
            avatar: require("../data/KV1.svg"),
            titleColor: "blue",
            reply: {
              title: noinhans === "" ? "@All" : noinhans,
              titleColor: "#8717ae",
              message: tensk,
            },
            status: hasRead ? "read" : undefined,
          });
        });
        //console.log(list.length, lastID, this.state.LastChatID, minID, this.state.MinChatID)
        if (list.length > 0 && (lastID > this.state.LastChatID || minID < this.state.MinChatID)) {
          this.setState(
            {
              dataChanged: false,
              canSaved: false,
              saving: false,
              errorLog: "",
              search_loading: false,
              search_result: list,
              LastChatID:
                lastID > this.state.LastChatID ? lastID : this.state.LastChatID,
              MinChatID: minID < this.state.MinChatID ? minID : this.state.MinChatID,
            },
            () => {
              this.scrollToBottom();
            }
          );
        }
      })
      .catch((error) =>
        this.setState({
          saving: false,
          search_loading: false,
          errorLog: error + "",
        })
      );
  };
  loadDanhMuc() {
    //load danh muc doi tac
    server
      .query("coquan/getall")
      .then((response) => {
        var list = [];
        response.map((item, index) => {
          if (item.MaCQ !== global.User.MaCQ) {
            list.push({ value: item.MaCQ, label: item.TenCoQuan });
          }
        });
        this.setState({ source_coquan: list, loading_coquan: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_coquan: false, errorLog: error + "" });
      });
    //load danh muc su kien co lien quan
    server
      .query(
        "sukien/getlienquan?trucbanid=" +
          (this.props.TrucBanID === undefined ? 0 : this.props.TrucBanID)
      )
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.MaSK, label: item.TenSK })
        );
        this.setState({ source_sukien: list, loading_sukien: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_sukien: false, errorLog: error + "" });
      });
  }
  scrollToBottom() {
    const scrollHeight = this.messageList.scrollHeight;
    const height = this.messageList.clientHeight;
    const maxScrollTop = scrollHeight - height;
    this.messageList.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
  }
  handleConfirm(item) {
    //xac nhan 1 item da duoc xac nhan da doc
    server
      .post("chat/confirmRead", { ChatID: item.dataItem.ChatID })
      .then((response) => {
        //hien thi lai tin nhan
        item.dataItem.NoiNhans.map((n, i) => {
          if (n.MaCQ == global.User.MaCQ) {
            n.HasRead = true;
            item.status = "read";
          }
        });
        this.setState({ search_result: this.state.search_result });
        //cap nhat global
        //global.func_tinnhan(response);
        global.updateSoTinNhan(global.updateSoTinNhan_callback);
      })
      .catch((error) => console.log(error));
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <>
        <div className="chatContainer">
          <div
            className="messagelist"
            ref={(el) => {
              this.messageList = el;
            }}
          >
            <MessageList
              className="messageList2"
              lockable={true}
              toBottomHeight={300}
              dataSource={this.state.search_result}
              onTitleClick={(event) => this.handleConfirm(event)}
            />
          </div>
          <div className="inputChat">
            <Grid item xs={12}>
              <Grid container spacing={4} className={classes.inputChat}>
                <Grid item xs={6}>
                  <InputLabel id="labelCoquan">Nơi nhận(*):</InputLabel>
                  {this.state.loading_coquan ? (
                    <CircularProgress />
                  ) : (
                    <div style={{ zIndex: 99999 }}>
                      <SelectFilter
                        id="cboMaNoiNhan"
                        options={this.state.source_coquan}
                        placeholder=""
                        labelId="labelCoquan"
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        menuPosition={"fixed"}
                        isMulti={true}
                        value={this.state.MaNoiNhan}
                        onChange={(item) => this.setState({ MaNoiNhan: item })}
                      ></SelectFilter>
                    </div>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <InputLabel id="labelCoquan">Sự vụ liên quan:</InputLabel>
                  {this.state.loading_sukien ? (
                    <CircularProgress />
                  ) : (
                    <div style={{ zIndex: 99999 }}>
                      <SelectFilter
                        id="cboMaSK"
                        options={this.state.source_sukien}
                        placeholder=""
                        labelId="labelCoquan"
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        menuPosition={"fixed"}
                        value={this.state.MaSK}
                        onChange={(item) => this.setState({ MaSK: item })}
                      ></SelectFilter>
                    </div>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="txtNoiDung"
                    className={classes.textbox}
                    label="Nội dung(*):"
                    multiline
                    inputProps={{
                      maxLength: 500,
                    }}
                    onChange={(event) =>
                      this.setState({ NoiDung: event.target.value })
                    }
                    ref={(el) => {
                      this.txtNoiDung = el;
                    }}
                    value = {this.state.NoiDung}
                  />
                  {this.state.saving ? (
                    <CircularProgress />
                  ) : (
                    <IconButton
                      color="secondary"
                      disabled={!global.User.Quyen.R251}
                      onClick={() => {
                        this.handleSend();
                      }}
                    >
                      <SendIcon />
                    </IconButton>
                  )}
                  {this.state.errorLog !== "" ? this.state.errorLog : undefined}
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  textbox: {
    width: 500,
  },
});

export default withStyles(styles, { withTheme: true })(ChatOnlinePage);
